<template>
  <div class="meeting_group">
    <div class="form_box">
      <el-form :model="forms" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
        :label-position="'left'">
        <div class="form_top">
          <div class="form_top_right">
            <el-form-item label="是否父级" prop="isParent" :rules="[{ required: true, message: '请选择是否父级科室' }]">
              <el-select class="inputWith" v-model="forms.isParent" placeholder="请选择" @change="handleIsParentChange"
                :disabled="disableIsParent">
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="forms.isParent == 2" label="父级科室" prop="parentId"
              :rules="[{ required: true, message: '请选择父级科室' }]">
              <el-select class="inputWith" v-model="forms.parentId" placeholder="请选择父级科室">
                <el-option v-for="desk in checkDeskList" :key="desk.id" :label="desk.checkDeskName"
                  :value="desk.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="科室名称" prop="checkDeskName" :rules="[{ required: true, message: '科室名称不能为空' }]">
              <el-input class="inputWith" v-model="forms.checkDeskName" :autocomplete="'on'"></el-input>
            </el-form-item>
            <el-form-item label="院区" v-if="forms.isParent == 2" prop="hospitalAreaId">
              <el-select class="inputWith" v-model="forms.hospitalAreaId" placeholder="请选择院区">
                <el-option v-for="item in AreasList" :key="item.id" :label="item.areaName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="地址" prop="address">
              <el-input class="inputWith" v-model="forms.address" :autocomplete="'on'"></el-input>
            </el-form-item>
            <el-form-item label="负责人" prop="principalUser">
              <el-input class="inputWith" v-model="forms.principalUser" :autocomplete="'on'"></el-input>
              <!-- multiple 多选 
              <el-select
                class="inputWith"
                v-model="forms.principalUser"
                filterable
                remote
                reserve-keyword
                :remote-method="searchKeyword"
                placeholder="请选择"
              >
                <el-option
                  class="inputWith"
                  v-for="item in this.userList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>-->
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
              <el-input class="inputWith" v-model="forms.phone" :autocomplete="'on'"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form_btn">
          <el-form-item>
            <el-button type="primary" @click="handleSubmit()">保存 </el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
let pinyin = require("js-pinyin");
export default {
  components: {},
  data() {
    return {
      mname: "",
      key: "id",
      id: "",
      typeId: "",
      forms: {
        isParent: 1, // 默认是父级科室
        parentId: null, // 父级科室的ID
        hospitalAreaId: null
      },
      userList: [],
      checkDeskList: [],
      AreasList: [],
      disableIsParent: false
    };
  },
  props: ["onCancel", "id", "type"],
  created() {
    if (this.type === "edit") {
      this.id = this.id;
      this.handleSearch();
    }
    this.getCheckDeskList();
    this.getAreasList()
  },
  methods: {
    async getCheckDeskList() {
      let d = {};
      let res = await $utils.api.load("admin/system/check/list", d, "get");
      if (res.code == 200) {
        this.checkDeskList = res.rows;
      }
    },
    async getAreasList() {
      let d = {};
      let res = await $utils.api.load("admin/system/hospitalArea/selectDropDown", d, "get");
      if (res.code == 200) {
        this.AreasList = res.data;
      }
    },
    handleIsParentChange(value) {
      if (value) {
        this.forms.parentId = null;
      }
    },
    searchKeyword(e) {
      pinyin.setOptions({ checkPolyphone: false, charCase: 0 });
      if (e !== "") {
        let q = {};
        $utils.api.load("/admin/system/user/listAll", q).then((res) => {
          if (res && res.rows) {
            let ll = res.rows;
            let dropList = [];
            for (let index = 0; index < ll.length; index++) {
              const element = ll[index];
              let xx = {};
              xx.value = element.id;
              xx.name = element.nickName;
              dropList.push(xx);
            }
            let pinyinStr = pinyin.getCamelChars(e);
            let list = [];
            if (e === pinyinStr) {
              for (let i = 0; i < dropList.length; i++) {
                let upPinYin = "";
                let fullPinYin = "";
                if (dropList[i].name) {
                  upPinYin = pinyin.getCamelChars(dropList[i].name);
                  fullPinYin = pinyin.getFullChars(dropList[i].name);
                }
                if (
                  fullPinYin.toUpperCase().includes(pinyinStr.toUpperCase()) ||
                  upPinYin.toUpperCase().includes(pinyinStr.toUpperCase())
                ) {
                  list.push(dropList[i]);
                }
              }
            } else {
              for (let i = 0; i < dropList.length; i++) {
                if (dropList[i].name) {
                  if (dropList[i].name.includes(e)) {
                    list.push(dropList[i]);
                  }
                }
              }
            }
            this.userList = list;
          }
        });
      } else {
        this.loaduserData();
      }
    },
    async handleSearch() {
      let res = await $utils.api.load(`/admin/system/check/${this.id}`);
      try {
        if (res) {
          this.forms = res.data;
          if (res.data.children && res.data.children.length > 0) {
            this.disableIsParent = true;
          } else {
            this.disableIsParent = false;
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    loaduserData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/user/listAll", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.nickName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          this.userList = dropList;
        }
      });
    },
    handleSubmit() {
      let q = this.forms;
      console.log(q);
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/admin/system/check`, q, this.type == "edit" ? "PUT" : "POST")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                this.$emit("onCancel");
                $utils.url.go(0);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.meeting_group {
  .form_box {
    .inputWith {
      width: 400px;
    }

    .inputWithTime {
      width: 200px;
    }

    .form_top,
    .form_bottom {
      display: flex;
    }

    .form_top {
      margin-bottom: 40px;

      .facilityType_class {
        padding-left: 100px;
        color: red;
        cursor: pointer;
      }

      .center-02 {
        width: 300px;
        border-radius: 10px;
        padding: 10px;
        box-sizing: border-box;
        box-shadow: 1px 2px 5px #8c939d;
        margin-left: 10px;
      }
    }

    .form_top_left,
    .form_bottom_left {
      width: 150px;
    }

    .form_top_left_text,
    .form_bottom_left_text {
      height: 40px;
      line-height: 40px;
      margin: 0 40px;
    }

    .form_bottom {
      margin-bottom: 20px;
    }

    .form_btn {
      margin-left: 150px;
    }
  }
}
</style>
